var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',{attrs:{"type":"flex","vs-justify":"center","vs-align":"center","vs-w":"12"}},[_c('iframe',{ref:"stylizationsList",attrs:{"id":"stylizationsList","src":_vm.stylizationListUrl},on:{"load":_vm.setFrameLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }